export default function WhatsAppButton({ settings }) {
  const num = (settings?.whatsapp_number || "").replace(/\D/g, "");
  if (!num) return null;
  const msg = encodeURIComponent(settings?.whatsapp_message || "Hello");
  const href = `https://wa.me/${num}?text=${msg}`;
  const onClick = () => {
    try {
      if (window.posthog?.capture) {
        window.posthog.capture("whatsapp_cta_clicked", {
          path: window.location?.pathname,
        });
      }
    } catch {}
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <div className="absolute inset-0 rounded-full bg-[#C9A050]/30 animate-ping" style={{ animationDuration: "2.5s" }} />
      <div className="relative w-14 h-14 rounded-full bg-[#0A0A0C] border border-[#C9A050]/60 flex items-center justify-center shadow-[0_8px_30px_rgba(201,160,80,0.15)] group-hover:border-[#C9A050] transition-all">
        <svg viewBox="0 0 24 24" className="w-6 h-6 fill-[#C9A050]" aria-hidden="true">
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.66 4.05 1.8 5.65L2 22l4.59-1.2a9.86 9.86 0 0 0 5.45 1.65h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.02A9.83 9.83 0 0 0 12.04 2zm0 18.13a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-2.72.71.72-2.65-.19-.3a8.21 8.21 0 0 1-1.26-4.35c0-4.53 3.69-8.22 8.23-8.22 2.2 0 4.26.86 5.81 2.41a8.17 8.17 0 0 1 2.41 5.82c0 4.54-3.7 8.23-8.23 8.23l-.29-.32zm4.51-6.15c-.25-.12-1.46-.72-1.68-.8-.23-.08-.39-.12-.56.12-.16.25-.64.8-.78.96-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.48-1.37-1.72-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.33-.76-1.82-.2-.48-.4-.41-.55-.42h-.47c-.17 0-.43.06-.66.31-.23.25-.87.84-.87 2.06 0 1.21.88 2.38 1 2.55.13.17 1.74 2.64 4.22 3.71.59.25 1.05.4 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.46-.6 1.67-1.17.21-.58.21-1.07.14-1.17-.06-.12-.22-.19-.47-.31z" />
        </svg>
      </div>
    </a>
  );
}
